import angular from 'angular';
import { forEach } from 'lodash';

module.exports = angular.module('common.models.assignee', [
  'server.common-constants'
])
.factory('Assignee', function($http) {
  var assigneeList = {
    null: {
      full_name: '',
      email: 'contact@opendoor.com',
      image: 'https://images.opendoor.com/source/s3/imgdrop-production/64d254e6888e45d9a688f7d5f19a674c.jpg?service=web'
    }
  };

  Object.defineProperty(assigneeList, '$promise', { value: $http.get('/api/v1/assignees') });
  assigneeList.$promise.then(function(response) {
    forEach(response.data, function(obj) {
      assigneeList[obj.id] = obj;
    });
  });

  return assigneeList;
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/models/assignee.js
 **/